{
    "META_TITLE": "{realEstateGroup} reviews | {score}/10 - HouseMatch geverifiëerde reviews",
    "META_DESCRIPTION": "Vind de beste makelaar voor u op basis van het grootste aantal geverifiëerde reviews in België.",
    "META_TITLE_REVIEW": "{score}/10 voor {realEstateGroup}. Bekijk alle reviews!"
}
